module.exports = __webpack_public_path__ + "media/images/device-desktop-icon-c98fe4240aa1881895b3ac97362c8965.svg";